import { getLocationPath } from '../../helpers';

const CardRegiClose = {
  render: async () => {
    return ``;
  },
  afterRender: async () => {
    const locationPath = getLocationPath();

    window.parent.location.replace(`${locationPath}#close`);
  },
};
export default CardRegiClose;
